import Main from "./Main";
import Navbar from "./Navbar";
import "./Home.css";

function Home() {
  return (
    <div className="home-cont">
      <Navbar />
      <Main />
    </div>
  );
}

export default Home;
